import React from 'react';
import EnrichmentSectionCard from './EnrichmentSectionCard';
import { sortEnrichmentEntries } from './sectionMeta';

function EnrichmentPanel({ enrichments, detectedType, emptyMessage = 'No enrichment sections yet.' }) {
  const entries = Object.entries(enrichments || {}).filter(([key]) => key !== 'error');
  const sorted = sortEnrichmentEntries(entries, detectedType);

  if (sorted.length === 0) {
    return <p className="enrichment-empty-page">{emptyMessage}</p>;
  }

  return (
    <div className="enrichment-panel">
      {sorted.map(([key, value]) => (
        <EnrichmentSectionCard
          key={key}
          sectionKey={key}
          detectedType={detectedType}
          section={value}
        />
      ))}
    </div>
  );
}

export default EnrichmentPanel;
